<template>
  <div class="px-2">
    <div class="d-flex align-items-center mb-2">
      <button class="btn btn-primary" @click="showModal = true">
        Subir archivo
      </button>

      <button
        class="btn btn-outline-primary ml-2"
        @click="showTemplatesModal = true"
      >
        Plantillas
      </button>
    </div>

    <b-card no-body>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Nombre de archivo</th>
              <th>Tipo</th>
              <th>Fecha de Subida</th>
              <th class="text-center" style="width: 140px">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="4">Cargando…</td>
            </tr>
            <tr v-else-if="!batches.length">
              <td colspan="4">Sin archivos</td>
            </tr>
            <tr v-for="b in batches" :key="b.id">
              <td>{{ b.originalName || b.filename }}</td>
              <td>{{ b.type }}</td>
              <td>{{ formatDate(b.created_at) }}</td>
              <td class="text-center">
                <button class="btn btn-danger btn-sm" @click="confirmDelete(b)">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <!-- Modal subir -->
    <b-modal
      id="upload-modal"
      v-model="showModal"
      title="Subir archivos"
      hide-footer
    >
      <div class="mb-2">
        <label class="form-label">Tipo de Excel</label>
        <select v-model="uploadType" class="form-control">
          <option value="IMPORT">Importación</option>
          <option value="SALE">Venta</option>
        </select>
      </div>

      <div class="mb-2">
        <label class="form-label">Archivo(s) Excel</label>
        <input
          type="file"
          multiple
          @change="onPickFiles"
          class="form-control"
        />
      </div>

      <div class="d-flex gap-1">
        <button
          class="btn btn-primary"
          :disabled="!files.length || uploading"
          @click="doUpload"
        >
          {{ uploading ? "Subiendo…" : "Subir" }}
        </button>
        <button class="btn btn-outline-secondary" @click="closeModal">
          Cerrar
        </button>
      </div>
    </b-modal>

    <!-- Modal plantilla -->
    <b-modal
      id="templates-modal"
      v-model="showTemplatesModal"
      title="Plantillas de Excel"
      hide-footer
    >
      <div class="mb-3">
        <p class="mb-2">
          - Para descargar la plantilla de ventas
          <a href="javascript:void(0)" @click.prevent="downloadSaleTemplate">
            click aqui
          </a>
        </p>
        <p class="mb-0">
          - Para descargar la plantilla de importacion
          <a href="javascript:void(0)" @click.prevent="downloadImportTemplate">
            click aqui
          </a>
        </p>
      </div>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-outline-secondary"
          @click="showTemplatesModal = false"
        >
          Cerrar
        </button>
      </div>
    </b-modal>

    <!-- Modal eliminar -->
    <b-modal
      id="delete-modal"
      v-model="showDeleteModal"
      title="Eliminar archivo"
      @hide="onDeleteHide"
      hide-footer
    >
      <h5 class="mb-2">
        ¿Eliminar el archivo “{{ toDeleteName }}”?
      </h5>
      <div class="d-flex gap-1">
        <button class="btn btn-danger" @click="doDelete">Eliminar</button>
        <button
          class="btn btn-outline-secondary"
          @click="showDeleteModal = false"
        >
          Cancelar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ReconFilesService from "@/services/ReconFilesService";
import ReconProcessService from "@/services/ReconProcessService";
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import * as XLSX from "xlsx";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: false,
      uploading: false,
      batches: [],
      showModal: false,
      uploadType: "IMPORT",
      showTemplatesModal: false,
      showDeleteModal: false,
      files: [],
      toDelete: null,
    };
  },
  mounted() {
    this.getBatches();
  },
  computed:{
    toDeleteName() {
        if (!this.toDelete) return "";
        return this.toDelete.originalName || this.toDelete.filename;
    },
  },
  methods: {
    formatDate(d) {
      if (!d) return "";
      try {
        return new Date(d).toLocaleString();
      } catch {
        return d;
      }
    },

    async getBatches() {
      this.loading = true;
      try {
        const resp = await ReconFilesService.listBatches(this.$store);
        this.batches = resp?.data?.batches || [];
      } catch (e) {
        console.error("Error listando batches", e);
        this.batches = [];
      } finally {
        this.loading = false;
      }
    },

    onPickFiles(ev) {
      this.files = Array.from(ev.target.files || []);
    },

    closeModal() {
      this.showModal = false;
      this.files = [];
      this.uploadType = "IMPORT";
    },

    showToast(msg, variant = "success") {
      if (this.$bvToast) {
        this.$bvToast.toast(msg, {
          title: "Importación / Venta",
          variant,
          solid: true,
          autoHideDelay: 4000,
        });
      } else {
        alert(msg);
      }
    },

    async doUpload() {
      if (!this.files.length || this.uploading) return;

      this.uploading = true;

      try {
        const r = await ReconFilesService.upload(
          this.files,
          this.uploadType,
          this.$store
        );

        const batches = r?.data?.data?.batches || r?.data?.batches || [];
        if (!batches.length) {
          console.warn("No se recibieron batches desde el backend");
          this.showToast("No se recibieron lotes desde el servidor.", "warning");
          return;
        }

        await Promise.all(
          batches.map(async (b) => {
            try {
              if (b.type === "IMPORT") {
                await ReconProcessService.processImport(b.batchId, this.$store);
              } else if (b.type === "SALE") {
                await ReconProcessService.processSale(b.batchId, this.$store);
              }
            } catch (err) {
              console.warn("Error procesando batch", b, err);
            }
          })
        );

        await this.getBatches();
        this.closeModal();
        this.showToast("Archivo(s) subido(s) y procesado(s) correctamente.");
      } catch (e) {
        console.error("Error subiendo", e);
        this.showToast("Ocurrió un error al subir los archivos.", "danger");
      } finally {
        this.uploading = false;
      }
    },

    confirmDelete(b) {
      this.toDelete = b;
    },

    onDeleteHide() {
      this.toDelete = null;
    },

    async doDelete() {
      if (!this.toDelete) return;
      try {
        await ReconFilesService.softDeleteBatch(this.toDelete.id, this.$store);
        this.toDelete = null;
        await this.getBatches();
        this.showToast("Archivo eliminado correctamente.");
      } catch (e) {
        console.error("Error eliminando", e);
        this.showToast("Ocurrió un error al eliminar el archivo.", "danger");
      }
    },

    downloadSaleTemplate() {
      const headers = [
        "FECHA EMISIÓN",
        "MES",
        "TIPO DE COMPROBANTE",
        "EMPRESA",
        "SERIE",
        "NUMERO",
        "DOC",
        "DOC ENTIDAD",
        "RUC",
        "Marca",
        "CODIGO ORG",
        "CODIGO ALT",
        "CANTIDAD",
      ];
      this.downloadExcel(headers, "plantilla_ventas.xlsx");
    },

    downloadImportTemplate() {
      const headers = ["Importador", "Fecha", "Codigo", "Cantidad"];
      this.downloadExcel(headers, "plantilla_importacion.xlsx");
    },

    downloadExcel(headers, filename) {
      const data = [headers];

      const worksheet = XLSX.utils.aoa_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla");

      const wbout = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([wbout], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.gap-1 > * + * {
  margin-left: 0.5rem;
}
</style>
